import React, { useState } from 'react';
import { Card, Alert, Button } from 'react-bootstrap';
import Header from './header';

import gradientImg from '../../assets/images/login-gradient.png';

import './finalStep.css';
import {NavLink, Route, Switch} from "react-router-dom";

const backgroundImg = {
  backgroundImage: `url(${gradientImg})`,
};

const FinalStep = () => {
  return (
    <div className="app">
      <Header />
      <div className="row m-0 final-step">
        <div
          className="col-12 d-flex justify-content-center align-items-center flex-column"
          style={backgroundImg}
        >
          <h3 className="text-center mb-3 get-started-title">
            The customer is all set!
          </h3>
          <Card className="final-step-card">
            <p className="text-center mb-2 get-started-description">
              The appointment has been scheduled for:
            </p>
            <h3 className="text-center mb-3 get-started-title">
              Tim Stanley
            </h3>

            <div className="final-step-address">
              <p  style={{'justify-content': 'center'}}><strong>March 4, 2021 at 10:00am</strong><br />
                Orange Plaza<br />
                Orange Plaza123 Main Street AnyTown CA</p>
            </div>
            <div className="final-step-code">
              <p className="text-left mb-0">
                Patient ID: <span>5321</span>
              </p>
              <p className="text-left mb-0">
                Confirmation Code: <span>12345</span>
              </p>
            </div>
          </Card>
          <div className="d-flex align-items-center justify-content-between mt-3 final-step-buttons">
            <Button className="cancel-btn" variant="light" block>
              Cancel Appointment
            </Button>
            <div className="d-flex">
              <Button className="send-btn mr-2" variant="light">
                Send a Reminder By Mail
              </Button>
              <NavLink to='/schedule/'>
              <Button className="send-btn mr-2" variant="light">
                Edit
              </Button>
              </NavLink>
              <Button className="print-btn" variant="light">
                Print
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalStep;
